import { SearchResponse } from '@models';
import { BaseComponent } from '../base.component';
import defaultHtml from './search-results.component.hbs';

export class SearchResultsComponent extends BaseComponent<SearchResponse> {
    protected override bindEvent = 'hawksearch:bind-search-results';
    protected override customTemplatePropertyName = 'searchResults';
    protected override defaultHtml = defaultHtml;

    protected getContentHtml(template: HandlebarsTemplateDelegate): string {
        const html = template({
            data: this.data
        });

        return html;
    }
}
